import { useCallback, useRef, useState } from 'react'
import { useCollectRecurrenceTargetRangeModal } from '../components/modals/CollectRecurrenceTargetRangeModal'

export function useCollectTargetRange() {
  const { show: showCollectRecurrenceTargetModal, Modal } = useCollectRecurrenceTargetRangeModal()

  const [allowedTargetRanges, setAllowedTargetRanges] =
    useState<uui.domain.ui.forms.RecurrenceCollectedTargetRange>({
      ORDER: { visible: true, disabled: false },
      FUTURE: { visible: true, disabled: false },
      ALL: { visible: true, disabled: false },
    })

  const collectTargetRangePromiseRef = useRef<{
    resolve: (value: uui.domain.ui.forms.TargetRange) => void
    reject: (reason?: any) => void
  }>()

  const collectTargetRange = useCallback(async (): Promise<uui.domain.ui.forms.TargetRange> => {
    return new Promise<uui.domain.ui.forms.TargetRange>((resolve, reject) => {
      collectTargetRangePromiseRef.current = { resolve, reject }
      showCollectRecurrenceTargetModal()
    })
  }, [showCollectRecurrenceTargetModal])

  return {
    allowedTargetRanges,
    setAllowedTargetRanges,
    collectTargetRange,
    collectTargetRangePromiseRef,
    Modal,
  }
}
